var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChatLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 146,
    viewBox: "0 0 200 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12041_35155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6934 73.8906H198.85V128.765H192.518V143.117L178.166 128.765H31.6934V73.8906Z",
    fill: "#FFE5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.207 79.2344H36.3364V123.134H194.207V79.2344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.042 92.0508H49.0317V94.3575H125.042V92.0508Z",
    fill: "#FA4616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.512 100.027H49.0317V102.334H181.512V100.027Z",
    fill: "#FFE5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.382 108.008H49.0317V110.315H181.382V108.008Z",
    fill: "#FFE5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.302 0.441406H2.14551V55.3159H8.47723V69.668L22.8289 55.3159H169.302V0.441406Z",
    fill: "#FFE5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.659 5.78516H6.78857V49.6849H164.659V5.78516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7604 19.0234H20.75V21.3302H96.7604V19.0234Z",
    fill: "#FA4616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.23 27.0039H20.75V29.3106H153.23V27.0039Z",
    fill: "#FFE5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1 34.9844H20.75V37.2911H153.1V34.9844Z",
    fill: "#FFE5D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12041_35155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 144.615,
    fill: "white",
    transform: "translate(0 0.441406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChatLogo);
export default __webpack_public_path__ + "static/media/emptyChatLogo.e7197fa57f0ca8d3217a6d7df1c17509.svg";
export { ForwardRef as ReactComponent };